export class WebCallError extends Error {
  name = 'WEB_CALL_ERROR'

  constructor(message?: string) {
    super(`Failed to communicate with app: ${message}`)
  }
}
